export default "__VITE_ASSET__TpIdJwzc__"